import React, { Suspense } from 'react'
import { Switch, Route, BrowserRouter, Redirect } from 'react-router-dom'
import { ROUTE_CONSTANTS } from '../constants/RouteConstants'
import { ProtectedRoute } from '../components/protected-routes/ProtectedRoute'
import { Loader } from '../components/ui/loader/Loader'
import { ErrorBoundary } from '../components/error-boundary/ErrorBoundary'
import TokenHandler from '../services/SSO/TokenHandler'
import { ROUTE_CONSTANTS_VERSION_0 } from '../version-0/src/constants/RouteConstants'
import { useSelector } from 'react-redux'
import { RootState } from '../reduxToolkit/store'

const LoginLazyComponent = React.lazy(() => {
  return new Promise<void>((resolve) => {
    resolve()
  }).then(() => import('../pages/login-oneplatform/Login'))
})

const LayoutLazyComponent = React.lazy(() => {
  return new Promise<void>((resolve) => {
    resolve()
  }).then(() => import('../pages/layout/Layout'))
})
const LandingLazyComponent = React.lazy(() => {
  return new Promise<void>((resolve) => {
    resolve()
  }).then(() => import('../../src/version-0/src/pages/LandingPage/LandingPage'))
})
const WorkspaceLazyComponent = React.lazy(() => {
  return new Promise<void>((resolve) => {
    resolve()
  }).then(() => import('../../src/pages/WorkspaceList/index'))
})
const WorkspacesLazyComponent = React.lazy(() => {
  return new Promise<void>((resolve) => {
    resolve()
  }).then(() => import('../../src/pages/workspace/workspace'))
})
const NewUserManagement = React.lazy(() => {
  return new Promise<void>((resolve) => {
    resolve()
  }).then(() => import('../pages/newUserManagement'))
})










export const RouterConfig: React.FC = () => {
  const { token }: any = useSelector((state: RootState) => state.authSlice);
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Switch>
        <Route
          exact
          path="/"
          render={() => {
          return token ? (
          <Redirect to={ROUTE_CONSTANTS_VERSION_0.Landing} />
          ) : (
          <Redirect to={ROUTE_CONSTANTS.LOGIN} />
          );
          }}
        />
          <Route
            exact
            path={ROUTE_CONSTANTS.LOGIN}
            render={() => (
              <Suspense fallback={<Loader loaderHeight="calc(100vh - 10px)" />}>
                <LoginLazyComponent></LoginLazyComponent>
              </Suspense>
            )}
          >
          </Route>

          <Route
            path={ROUTE_CONSTANTS_VERSION_0.Landing}
            render={() => (
              <Suspense fallback={<Loader loaderHeight="calc(100vh - 10px)" />}>
                <LandingLazyComponent />
              </Suspense>
            )}
          />
          <Route
            path={ROUTE_CONSTANTS_VERSION_0.WORKSPACE}
            render={() => (
              <Suspense fallback={<Loader loaderHeight="calc(100vh - 10px)" />}>
                <WorkspaceLazyComponent />
              </Suspense>
            )}
          />
                    <Route
            path={ROUTE_CONSTANTS.WORKSPACE}
            render={() => (
              <Suspense fallback={<Loader loaderHeight="calc(100vh - 10px)" />}>
                <WorkspacesLazyComponent />
              </Suspense>
            )}
          />
          <Route
            path={ROUTE_CONSTANTS.NewUserManagement}
            render={() => (
              <Suspense fallback={<Loader loaderHeight="calc(100vh - 10px)" />}>
                <NewUserManagement/>
              </Suspense>
            )}
          />
          <Route exact path="/token" component={TokenHandler} />

          <ProtectedRoute
            path={ROUTE_CONSTANTS.LAYOUT}
            component={LayoutLazyComponent}
          />
          <Redirect from="*" to={ROUTE_CONSTANTS.LOGIN} />
        </Switch>
      </ErrorBoundary>
    </BrowserRouter>
  )
}
